import { createApp } from "vue";
import BlackthornEvent from "./BlackthornEvent.vue";
import handleComponentProps from "../../foundation/js/utils/handleComponentProps";

const el = '.nyk-component--blackthorn-event';

export default function (Store) {
    const DOM = document.querySelectorAll(el);
    if (DOM.length) {
        DOM.forEach((BlackthornEventDOM, index) => {
            const props = handleComponentProps(BlackthornEvent, BlackthornEventDOM);
            const ariaLabels = BlackthornEventDOM.dataset.ariaLabels ? JSON.parse(BlackthornEventDOM.dataset.ariaLabels) : {};
            const component = createApp(BlackthornEvent, { ...props, ariaLabels });
            if (Store) {
                component.use(Store);
            }
            component.mount(BlackthornEventDOM);
        });
    }
}
